module.exports = __webpack_public_path__ + "img/school.ad74ae0f.png";